import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconWifi6({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#CD0400"
					d="M11.856 17.055c.814 0 1.548.48 1.86 1.215a1.94 1.94 0 0 1-.437 2.145 2.05 2.05 0 0 1-2.194.425 1.97 1.97 0 0 1-1.241-1.819c.001-1.085.902-1.965 2.012-1.966m0 1.45c-.472 0-.708.559-.374.884.335.326.905.094.904-.368a.525.525 0 0 0-.53-.516m-4.012-4.936a7.66 7.66 0 0 1 6.798-.612v1.593a6.14 6.14 0 0 0-6.002.243.75.75 0 0 1-1.033-.217.716.716 0 0 1 .237-1.007m-2.398-3.413a11.94 11.94 0 0 1 9.235-1.529q-.04.302-.04.627v.863a10.43 10.43 0 0 0-8.381 1.252c-.827.53-1.64-.682-.814-1.213M3.054 6.732C7.824 3.653 13.86 3.325 18.9 5.748h-.667c-.801 0-1.491.173-2.046.495A14.77 14.77 0 0 0 3.873 7.941a.75.75 0 0 1-1.037-.198.716.716 0 0 1 .218-1.01"
				/>
				<path
					fill="#FFF"
					d="M11.144 15.908c.814 0 1.548.479 1.86 1.215a1.94 1.94 0 0 1-.438 2.144 2.05 2.05 0 0 1-2.194.426 1.97 1.97 0 0 1-1.24-1.819c0-1.086.901-1.965 2.012-1.966m0 1.45c-.473 0-.709.558-.374.884s.904.094.903-.368a.525.525 0 0 0-.53-.517m-4.012-4.936a7.65 7.65 0 0 1 7.508-.291v1.618a.8.8 0 0 1-.28-.103 6.14 6.14 0 0 0-6.433 0 .75.75 0 0 1-1.033-.218.716.716 0 0 1 .238-1.006M4.733 9.009a11.95 11.95 0 0 1 10.173-1.26c-.174.44-.265.944-.265 1.505v-.06a10.43 10.43 0 0 0-9.094 1.028c-.827.53-1.64-.683-.814-1.213M2.341 5.585a16.28 16.28 0 0 1 17.605 0q.113.07.19.169a7 7 0 0 0-.256-.006h-1.647q-.459.001-.867.074c-4.537-2.11-9.932-1.787-14.206.972a.75.75 0 0 1-1.037-.198.716.716 0 0 1 .218-1.01"
				/>
				<path
					fill="#FFF"
					fillRule="nonzero"
					d="M19.88 19.9h-1.647q-2.12 0-2.12-2.065V9.254q0-2.067 2.12-2.066h1.647q2.12 0 2.12 2.066v1.207q0 .398-.408.398h-1.06q-.407 0-.407-.398v-.365q0-.7-.245-.89t-.8-.19q-.357 0-.562.047-.204.047-.367.302t-.163.73v1.812q0 .27.098.366t.359.095h1.435q2.12 0 2.12 2.066v3.401q0 2.066-2.12 2.066m-1.814-1.867q.235.189.86.189.623 0 .867-.197.245-.196.245-.873v-1.699q0-.675-.245-.873-.244-.196-.868-.196-.623 0-.86.196-.235.198-.235.873v1.7q0 .675.236.88"
				/>
			</g>
		</svg>
	);
}
